import { RetryModule } from './../../../shared/component/common/retry/retry.module';
import { RadioModule } from './../../../shared/component/common/radio/radio.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MaritalStatusPageComponent } from './marital-status.page';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { InputModule } from '../../../shared/component/common/input/input.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    RadioModule,
    RetryModule,
  ],
  declarations: [MaritalStatusPageComponent]
})
export class MaritalStatusPageModule {}
